// This file is purposely seperate because it imports both react and react-dom
// library. It is more like a helpers file but just do not want to force helpers
// file depend on react-dom.
import React, { PureComponent, useState } from "react";
import ReactDOM from "react-dom/client";
import update from 'immutability-helper';
import { push as _push } from 'connected-react-router';
import { I, L } from './config';
import {
	emptyObject
	, BTN_SAVE_AS_EML
	, C3ERR_SAME_ID
	, PLF_PREVIEW
	, SAVE_AS_EML_STR
	, SEARCH_ERRANDS
	, SEARCH_NEW_ERRANDS
	, SEARCH_MY_ERRANDS
	, SEARCH_CLOSE_ERRANDS
} from "./constants";
import { expireCookie, getCookie, hasPrefix, uuidv4 } from "../helpers";
import { V5, ADMIN } from '../path';
import { PostForm } from "../../reactcomponents/Form";
import { popupWithMaxDim } from "../../reactcomponents/PopupPage";

export function openPreviewWindowWithPost(url, params) {
	return new Promise((resolve, reject) => {
		const res = window.open("", '_blank');
		if (!res) {
			reject({err: "open window return " + res});
		} else {
			const newDiv = document.createElement("div");
			res.document.body.appendChild(newDiv);
			const elem = ReactDOM.createRoot(newDiv);
			res.addEventListener('beforeunload', e => {
				console.log("window open before unload");
				ReactDOM.unmountComponentAtNode(elem);
			});
			res.addEventListener('load', e => {
				console.log("window open load");
			});
			resolve(elem.render(
				<PostForm params={params} url={url} />
			));
		}
	});
}

const tokenCookieDetectionInterval = 1000
	, tokenCookieDetectionAttempts = 120
	, noTokenCookie = "can't find token cookie after attempts "
		+ tokenCookieDetectionAttempts + " times with interval "
		+ tokenCookieDetectionInterval + " miliseconds per attempt."
	, invisible = {display: "none"}
	, maxSize = {width: "100%", height: "100%"}
	;
class PostLinkBase extends PureComponent {
	constructor(props) {
		super(props);
		this.setRef = this.setRef.bind(this);
	}
	tokenCookieDetection(tokenName, tokenValue) {
		// implementing logic of this suggestion: https://stackoverflow.com/a/4168965/1778714
		let _cancelled = false
			, cookieDetectTimer
			, rejecter
			, previousDoc = this.rootRef.contentDocument
			;
		return [
			new Promise((resolve, reject) => {
				let attempts = tokenCookieDetectionAttempts;
				rejecter = reject;
				cookieDetectTimer = window.setInterval(() => {
					const doc = this.rootRef.contentDocument
						, returnToken = getCookie(doc, tokenName)
						, foundValidToken = returnToken == tokenValue
						;
					if (foundValidToken || attempts == 0) {
						window.clearInterval(cookieDetectTimer);
						expireCookie(doc, tokenName);
						if (foundValidToken) {
							resolve();
						} else {
							reject({reason: noTokenCookie});
						}
						return;
					}
					attempts--;
				}, tokenCookieDetectionInterval);
			})
			, reason => {
				if (!_cancelled) {
					if (cookieDetectTimer) {
						window.clearInterval(cookieDetectTimer);
					}
					_cancelled = true;
					rejecter({isCancelled: true, reason});
				}
			}
		];
	}
	cancelPreviousToken(reason) {
		if (this.cancel) {
			this.cancel(reason);
			this.cancel = null;
		}
	}
	listenEvents(rootRef) {
		$(window).on(
			"message.iframe"
			, ({ originalEvent }) => {
				if (originalEvent && originalEvent.data) {
					const err = originalEvent.data.error;
					if (err) {
						this.cancelPreviousToken(err);
					}
				}
			}
		);
	}
	setRef(ref) {
		this.rootRef = ref;
		this.listenEvents(ref);
	}
	createNativeMountNode() {
		const newDiv = document.createElement("div");
		const elem = ReactDOM.createRoot(newDiv);
		this.elem = elem;
		this.rootRef.contentDocument.body.appendChild(newDiv);
	}
	cleanIframeBody() {
		const body = this.rootRef.contentDocument.body;
		while (body.lastChild) {
			body.removeChild(body.lastChild);
		}
	}
	clearPreviousMountNode() {
		if (!this.elem) {
			return;
		}
		this.cancelPreviousToken("next request start before previous action stop");
		this.cleanIframeBody();
		this.elem = null;
	}
	iframePostForm() {
		this.clearPreviousMountNode();
		this.createNativeMountNode();
		const { token, src } = this.props;
		if (!src) {
			return;
		}
		const { elem } = this
			, { format, data } = src
			, { url } = data
			;
		let params = data.params;
		this.props.onBeforeStart(format);
		if (token) {
			const { field, name } = token
				, value = uuidv4()
				, [ promise, cancel ] = this.tokenCookieDetection(name, value)
				;
			params = update(params, {[field]: {$set: value}});
			this.cancel = cancel;
			promise.then(() => this.props.onEnd())
				.catch(err => this.props.onError(err));
		}
		this.elem.render(
			<PostForm
				loading={format === PLF_PREVIEW}
				params={params}
				url={url}
			/>
		);
	}
	componentDidMount() {
		this.iframePostForm();
	}
	componentDidUpdate(prevProps) {
		if (prevProps.src !== this.props.src) {
			this.iframePostForm();
		}
	}
	componentWillUnmount() {
		$(window).off("message.iframe");
		this.clearPreviousMountNode();
	}
	render() {
		const { src } = this.props;
		let style;
		if (src && src.format === PLF_PREVIEW) {
			style = maxSize;
		} else {
			style = invisible;
		}
		return <iframe ref={this.setRef} style={style} frameBorder="0" />;
	}
}

const downloadToken = {
	field: "download_token"
	, name: "downloadToken"
};

const PostDownload = props => <PostLinkBase token={downloadToken} {...props} />;

const previewButtons = [
	{
		id: BTN_SAVE_AS_EML
		, text: SAVE_AS_EML_STR
	}
];

const Popup = popupWithMaxDim(100);

// TODO: refactor to use createWithPopupWrapper
export const PreviewWithPost = ({ onClick, onClose, show, ...props }) => (
	<Popup
		// TODO: allow save as eml inside preview frame but this requires
		// seperate iframe container.
		// buttons={previewButtons}
		onClick={onClick}
		onClose={onClose}
		show={show}
	>
		<PostLinkBase {...props} />
	</Popup>
);

export const PostIframeLink = props => {
	if (props.src && props.src.format === PLF_PREVIEW) {
		return <PreviewWithPost {...props} />;
	}
	return <PostDownload {...props} />;
};

export const IsContextSearch = (context) =>{
	switch (context) {
		case SEARCH_ERRANDS:
		case SEARCH_NEW_ERRANDS:
		case SEARCH_MY_ERRANDS:
		case SEARCH_CLOSE_ERRANDS:
			return true;
	}
	return false;
}

// like react-router-redux push but more suitable for c3 environment and return
// promise to know if it is V5 page or not.
export const push = (url, ...args) => dispatch => {
	let pathname;
	const urlType = typeof url;
	if (urlType === "string") {
		pathname = url;
	} else if (urlType === "object") {
		pathname = url.pathname;
	}
	
	// Transform old WhatsApp template route to v5 route
	if (pathname && (pathname.includes('/templates/whatsapp') || pathname.includes('#templates/whatsapp'))) {
		// Extract hash if present (e.g., #templates/whatsapp/list)
		const hashMatch = pathname.match(/#templates\/whatsapp(\/.*)?/);
		if (hashMatch) {
			pathname = `${ADMIN}/templates/whatsapp`;
		} else if (pathname.includes('/templates/whatsapp')) {
			// Handle direct path like /templates/whatsapp/list
			pathname = `${ADMIN}/templates/whatsapp`;
		}
		url = pathname;
	}
	
	if (!pathname || !hasPrefix(pathname, V5)) {
		window.location.href = url;
		return Promise.reject(url);
	}
	dispatch(_push(url, ...args));
	return Promise.resolve(url);
};

export const pushV5 = (context, params) => push(V5, {v5: {context, params}});

// TODO: check where this error come from. It is used by open errand which look
// rather weird and messy.
const customErrorCheck = err => typeof err.err !== "undefined"
	&& typeof err.err.message !== "undefined"
	&& err.err.message.length > 0;

function isSameIDError(err) {
	if (err === C3ERR_SAME_ID) {
		return true;
	} else if (err.sameID) {
		return true;
	}
	return false;
}

function isAbortAJAX(err) {
	if (err.status === 0 && err.statusText === "abort") {
		return true;
	}
	return false;
}

function jsonErrorToString(err, stringify) {
	const messageTypeOf = typeof err.message;
	if (messageTypeOf === "string") {
		return L(err.message);
	} else if (typeof err.error !== "undefined") {
		return L(err.error);
	} else if (messageTypeOf !== "undefined") {
		return L(err.message);
	} else if (stringify) {
		return stringify;
	}
	return err + "";
}

const undefinedError = I("Error is undefined");

export const ERRTYPE_UNDEFINED = 0
	, ERRTYPE_STRING = 1
	, ERRTYPE_FALSY = 2
	, ERRTYPE_OPEN_ERRAND = 3
	, ERRTYPE_RESPONSEJSON = 4
	, ERRTYPE_SAME_ID = 5
	, ERRTYPE_ABORTED_AJAX = 6
	, ERRTYPE_THE_REST = 7 // this MUST be always last item
	;
const arrayErrorHandlers = [
		{ // ERRTYPE_UNDEFINED
			def: false
			, check: err => typeof err === "undefined"
			, msg: () => "undefined error input argument"
		}
		, { // ERRTYPE_FALSY
			def: false
			, check: err => !err
			, msg: err => `error '${err}' is falsy value`
		}
		, { // ERRTYPE_STRING
			def: true
			, check: err => typeof err === "string"
			, msg: err => err
		}
		, { // ERRTYPE_OPEN_ERRAND
			def: true
			, check: err => customErrorCheck(err)
			, msg: err => err.err.message
		}
		, { // ERRTYPE_RESPONSEJSON
			def: true
			, check: err => typeof err.responseJSON !== "undefined"
			, msg: err => jsonErrorToString(err.responseJSON, err.responseText)
		}
		, { // ERRTYPE_SAME_ID
			def: true
			, check: err => isSameIDError(err)
			, msg: ({ sameID }) => `Aborted operation on same ID ${sameID}.`
		}
		, { // ERRTYPE_ABORTED_AJAX
			def: false
			, check: err => isAbortAJAX(err)
			, msg: () => "AJAX request is aborted"
		}
		, { // ERRTYPE_THE_REST
			def: true
			, check: () => true
			, msg: err => jsonErrorToString(err, undefinedError)
		}
	]
	;
function isErrorCheck(modifier, index, def) {
	if (modifier && typeof modifier[index] !== "undefined") {
		return !!modifier[index];
	}
	return def;
}

export function analyzeError(err, custom) {
	const lastIndex = arrayErrorHandlers.length - 1;
	for (let i=0; i<lastIndex; i++) {
		const { def, check, msg } = arrayErrorHandlers[i];
		if (check(err)) {
			return [isErrorCheck(custom, i, def), msg(err)];
		}
	}
	const { def, check, msg } = arrayErrorHandlers[lastIndex];
	return [isErrorCheck(custom, lastIndex, def), msg(err)];
}

export function getMinutesBetweenDates(startDate, endDate) {
    var diff = endDate.getTime() - startDate.getTime();
    return (diff / 60000);
}

export function ClipboardCopy({ copyText }) {
	const [isCopied, setIsCopied] = useState(false);
	async function copyTextToClipboard(text) {
		if ('clipboard' in navigator) {
			return await navigator.clipboard.writeText(text);
		} else {
			return document.execCommand('copy', true, text);
		}
	}
	const handleCopyClick = () => {
		copyTextToClipboard(copyText)
		.then(() => {
			setIsCopied(true);
			setTimeout(() => {
				setIsCopied(false);
			}, 1500);
		})
		.catch((err) => {
			console.log(err);
		});
	}

	return (<div>
			<i className="icon-copy" title={I('Copy answer')} onClick={handleCopyClick}></i>
			<span>{isCopied ? I('Copied!') : ''}</span>
	</div>);
}

export function copyPlainTextToClipboard(text, isFormatted = false) {
	const tempElement = document.createElement('div');
	if (isFormatted) {
		tempElement.innerHTML = text;
	} else {
		tempElement.textContent = text;
	}
	document.body.appendChild(tempElement);

	const range = document.createRange();
	range.selectNodeContents(tempElement);
	const selection = window.getSelection();
	selection.removeAllRanges();
	selection.addRange(range);

	const copySuccess = () => {
		console.log('Text copied to clipboard');
		document.body.removeChild(tempElement);
	};

	const copyFail = (err) => {
		console.error('Error copying text:', err);
		document.body.removeChild(tempElement);
	};

	if (navigator.clipboard && navigator.clipboard.writeText) {
		navigator.clipboard.writeText(selection.toString())
			.then(copySuccess)
			.catch(copyFail);
	} else {
		try {
			document.execCommand('copy');
			copySuccess();
		} catch (err) {
			copyFail(err);
		}
	}
}

export function copyTextToClipboard(text) {
	const tempElement = document.createElement('div');
	tempElement.innerHTML = text;
	document.body.appendChild(tempElement);

	const range = document.createRange();
	range.selectNodeContents(tempElement);
	const selection = window.getSelection();
	selection.removeAllRanges();
	selection.addRange(range);

    if (selection.rangeCount > 0) {
        const container = document.createElement('div');
        container.appendChild(range.cloneContents());
        const htmlContent = container.innerHTML; // Get HTML content
        const textContent = selection.toString(); // Get plain text

        // Check if the Clipboard API supports writing HTML
        if (navigator.clipboard && navigator.clipboard.write) {
            const blob = new Blob([htmlContent], { type: 'text/html' });
            const textBlob = new Blob([textContent], { type: 'text/plain' });

            const clipboardItem = new ClipboardItem({
                'text/html': blob,
                'text/plain': textBlob,
            });

            navigator.clipboard.write([clipboardItem]).then(() => {
                console.log('Formatted content copied to clipboard!');
            }).catch((err) => {
                console.error('Failed to copy:', err);
            });
        } else {
            console.error('Clipboard API does not support writing HTML.');
        }
    } else {
        console.error('No selection found to copy!');
    }
}

export function copyAllTextToClipboard(text) {
	const tempElement = document.createElement('div');
	tempElement.innerHTML = text;
	document.body.appendChild(tempElement);

	const range = document.createRange();
	range.selectNodeContents(tempElement);
	const selection = window.getSelection();
	selection.removeAllRanges();
	selection.addRange(range);

	if (selection.rangeCount > 0) {
		const container = document.createElement('div');
		container.appendChild(range.cloneContents());
		const htmlContent = container.innerHTML; // Get HTML content
		const textContent = selection.toString(); // Get plain text

		// Check if the Clipboard API supports writing HTML
		if (navigator.clipboard && navigator.clipboard.write) {
			const blob = new Blob([htmlContent], { type: 'text/html' });
			const textBlob = new Blob([textContent], { type: 'text/plain' });

			const clipboardItem = new ClipboardItem({
				'text/html': blob,
				'text/plain': textBlob,
			});

			navigator.clipboard.write([clipboardItem]).then(() => {
				console.log('Formatted content copied to clipboard!');
			}).catch((err) => {
				console.error('Failed to copy:', err);
				// Fallback to plain text if HTML copying fails
				navigator.clipboard.writeText(textContent);
			});
		} else {
			// Fallback for browsers that don't support ClipboardItem
			console.warn('Clipboard API does not support writing HTML, falling back to plain text.');
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(textContent);
			} else {
				// Final fallback using execCommand
				try {
					document.execCommand('copy');
					console.log('Text copied using execCommand fallback');
				} catch (err) {
					console.error('All clipboard methods failed:', err);
				}
			}
		}
	} else {
		console.error('No selection found to copy!');
	}

	document.body.removeChild(tempElement);
}


// Generate Integrity Hash for script using SHA-384
export async function generateIntegrityHash(url, algorithm = 'SHA-384') {
	const response = await fetch(url);

	if (!response.ok) {
		throw new Error(`Failed to load ${url} (HTTP status: ${response.status})`);
	}

	const blob = await response.blob();
	const data = await new Response(blob).arrayBuffer();
	const hashBuffer = await crypto.subtle.digest({ name: algorithm }, data);

	const hashArray = Array.from(new Uint8Array(hashBuffer));
	const base64Hash = btoa(String.fromCharCode.apply(null, hashArray));
	return "sha384-"+ base64Hash;
}

// Create Integrity Attribute
export async function createIntegrityAttr(src) {
	try {
		const hash = await generateIntegrityHash(src);
		return hash;
	} catch (error) {
		console.error(error);
		return ''; // Return an empty string or handle the error as needed
	}
}

// Element detection if element is at bottom of parent
export const isElementAtBottom = (elem, pa) => {
	if(pa) {
		const element = elem.current;
		const parent = pa.current;
		// Check if the element and its parent exist
		if (element && parent) {
			const elementRect = element.getBoundingClientRect();
			const parentRect = parent.getBoundingClientRect();
			const distanceToBottom = parentRect.bottom - elementRect.bottom;
			// Adjust the threshold as needed
			const threshold = 10; // Adjust this value based on your requirement
			return distanceToBottom <= threshold;
		} else {
			return false;
		}
	}
	return false;
};

export const isEmptyString = str => /^\s*$/.test(str);

/**
 * Converts a color string to RGB values
 * @param {string} color - Color in various formats (hex, rgb, rgba, named colors)
 * @returns {Object|null} - Object with r, g, b values or null if parsing fails
 */
function parseColorToRGB(color) {
	if (!color || color === 'transparent' || color === 'inherit' || color === 'initial') {
		return null;
	}

	// Handle hex colors
	if (color.startsWith('#')) {
		const hex = color.slice(1);
		if (hex.length === 3) {
			return {
				r: parseInt(hex[0] + hex[0], 16),
				g: parseInt(hex[1] + hex[1], 16),
				b: parseInt(hex[2] + hex[2], 16)
			};
		} else if (hex.length === 6) {
			return {
				r: parseInt(hex.substr(0, 2), 16),
				g: parseInt(hex.substr(2, 2), 16),
				b: parseInt(hex.substr(4, 2), 16)
			};
		}
	}

	// Handle rgb/rgba colors
	const rgbMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
	if (rgbMatch) {
		return {
			r: parseInt(rgbMatch[1], 10),
			g: parseInt(rgbMatch[2], 10),
			b: parseInt(rgbMatch[3], 10)
		};
	}

	// Handle named colors by creating a temporary element
	const tempEl = document.createElement('div');
	tempEl.style.color = color;
	document.body.appendChild(tempEl);
	const computedColor = window.getComputedStyle(tempEl).color;
	document.body.removeChild(tempEl);

	if (computedColor !== color) {
		return parseColorToRGB(computedColor);
	}

	return null;
}

/**
 * Calculates the relative luminance of a color
 * @param {Object} rgb - Object with r, g, b values
 * @returns {number} - Luminance value between 0 and 1
 */
function calculateLuminance(rgb) {
	const { r, g, b } = rgb;
	const [rs, gs, bs] = [r, g, b].map(c => {
		c = c / 255;
		return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
	});
	return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}

/**
 * Calculates contrast ratio between two colors
 * @param {Object} color1 - RGB object for first color
 * @param {Object} color2 - RGB object for second color
 * @returns {number} - Contrast ratio
 */
function calculateContrastRatio(color1, color2) {
	const lum1 = calculateLuminance(color1);
	const lum2 = calculateLuminance(color2);
	const lighter = Math.max(lum1, lum2);
	const darker = Math.min(lum1, lum2);
	return (lighter + 0.05) / (darker + 0.05);
}

/**
 * Determines if a color would be readable on a white background
 * @param {string} color - Color string to check
 * @returns {boolean} - True if readable, false if needs adjustment
 */
function isReadableOnWhite(color) {
	const whiteRGB = { r: 255, g: 255, b: 255 };
	const colorRGB = parseColorToRGB(color);

	if (!colorRGB) {
		return true; // If we can't parse the color, assume it's readable
	}

	const contrastRatio = calculateContrastRatio(colorRGB, whiteRGB);
	return contrastRatio >= 4.5; // WCAG AA standard for normal text
}

/**
 * Gets a readable alternative color for text on white background
 * @param {string} originalColor - Original text color
 * @returns {string} - Adjusted color that's readable on white
 */
function getReadableColorForWhite(originalColor) {
	if (isReadableOnWhite(originalColor)) {
		return originalColor;
	}

	const colorRGB = parseColorToRGB(originalColor);
	if (!colorRGB) {
		return '#000000'; // Default to black if parsing fails
	}

	// If the color is too light, make it darker
	const luminance = calculateLuminance(colorRGB);
	if (luminance > 0.5) {
		// Color is light, make it dark
		return '#333333'; // Dark gray instead of pure black for better readability
	}

	// If we reach here, return the original color
	return originalColor;
}

const BLANK_LINE_SEPARATOR = /(?:<br\s*\/?>(?:\s|&nbsp;|\u00a0)*){2,}/i;

/**
 * Convert raw pasted plain text (e.g. from a .txt file) into HTML while keeping
 * blank lines visible.
 *
 * CKEditor 5's own plainTextToHtml turns an empty line (\n\n) into a paragraph
 * separator, so the blank line disappears before any clipboard transformation
 * runs. We rebuild the HTML ourselves: consecutive non-empty lines stay in one
 * paragraph joined by <br>, and every blank line becomes a <p>&nbsp;</p> that
 * CKEditor 5 preserves.
 *
 * @param {string} text - The raw plain-text clipboard content
 * @returns {string} - HTML with blank lines preserved
 */
export function plainTextToHtmlPreservingBlankLines(text) {
	if (typeof text !== 'string' || text === '') {
		return text;
	}

	const escapeHtml = line => line
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		// Keep indentation/runs of spaces and tabs from collapsing.
		.replace(/\t/g, '\u00a0\u00a0\u00a0\u00a0')
		.replace(/ {2,}/g, match => '\u00a0'.repeat(match.length))
		.replace(/^ /, '\u00a0')
		.replace(/&nbsp;/g, '&nbsp;')
		.replace(/\u00a0/g, '&nbsp;');

	const lines = text.replace(/\r\n?/g, '\n').split('\n');
	const out = [];
	let buffer = [];

	const flush = () => {
		if (buffer.length) {
			out.push(`<p>${buffer.join('<br>')}</p>`);
			buffer = [];
		}
	};

	lines.forEach(line => {
		if (line.trim() === '') {
			flush();
			out.push('<p>&nbsp;</p>');
		} else {
			buffer.push(escapeHtml(line));
		}
	});

	flush();

	return out.join('');
}

export function preserveBlankLinesForPaste(htmlContent) {
	if (!htmlContent || typeof htmlContent !== 'string') {
		return htmlContent;
	}

	const tempDiv = document.createElement('div');
	tempDiv.innerHTML = htmlContent;

	Array.from(tempDiv.querySelectorAll('p, div')).forEach(block => {
		if (block.querySelector('img, table, ul, ol, iframe')) {
			return;
		}
		if (!BLANK_LINE_SEPARATOR.test(block.innerHTML)) {
			return;
		}

		const segments = block.innerHTML.split(BLANK_LINE_SEPARATOR);
		const parent = block.parentNode;
		const tag = block.tagName.toLowerCase() === 'div' ? 'p' : block.tagName.toLowerCase();

		segments.forEach((segment, index) => {
			if (index > 0) {
				const spacer = document.createElement('p');
				spacer.innerHTML = '&nbsp;';
				parent.insertBefore(spacer, block);
			}

			const content = segment.replace(/^(?:\s|&nbsp;|\u00a0)+|(?:\s|&nbsp;|\u00a0)+$/g, '');
			if (content === '') {
				return;
			}

			const newBlock = document.createElement(tag);
			Array.from(block.attributes).forEach(({ name, value }) => newBlock.setAttribute(name, value));
			newBlock.innerHTML = segment;
			parent.insertBefore(newBlock, block);
		});

		parent.removeChild(block);
	});

	// 2) Convert standalone blank block elements into <p>&nbsp;</p>. CKEditor 5
	// drops whitespace-only <div> blocks (e.g. <div> </div>, <div><br></div>,
	// <div><span> </span></div>) during upcast, so blank lines from rich-text or
	// .txt paste vanish. A block counts as blank when it carries no visible text
	// (any kind of whitespace: space, tab, nbsp, unicode spaces, zero-width) and
	// no embedded/void content. Only leaf blocks are touched so wrappers that hold
	// real blocks are left intact.
	Array.from(tempDiv.querySelectorAll('p, div')).forEach(block => {
		if (block.querySelector('p, div, img, table, ul, ol, iframe, hr, input, video, audio, object, svg, button')) {
			return;
		}

		// Strip every whitespace flavour, including zero-width and BOM chars that
		// JS \s does not cover, then check whether any real text remains.
		const hasText = block.textContent
			.replace(/[\s\u00a0\u200b\u200c\u200d\u2028\u2029\ufeff]/g, '')
			!== '';
		if (hasText) {
			return;
		}

		const paragraph = document.createElement('p');
		paragraph.innerHTML = '&nbsp;';
		block.parentNode.replaceChild(paragraph, block);
	});

	return tempDiv.innerHTML;
}

const PASTED_FONT_STYLE_PROPERTIES = new Set(['font', 'font-family', 'font-size']);

/**
 * Strip font family and size from pasted/inserted HTML so content inherits the
 * editor default. Inner inline fonts otherwise beat any wrapper span, and wrapping
 * blocks in a span also collapses blank lines.
 *
 * @param {ParentNode} root - DOM subtree to clean in place
 */
export function stripInlineFontStyles(root) {
	if (!root || typeof root.querySelectorAll !== 'function') {
		return;
	}

	root.querySelectorAll('[style]').forEach(el => {
		const style = el.getAttribute('style');
		if (!style) {
			return;
		}

		const remainingStyles = style
			.split(';')
			.map(part => part.trim())
			.filter(part => {
				const property = part.split(':')[0];
				if (!property) {
					return false;
				}

				return !PASTED_FONT_STYLE_PROPERTIES.has(property.trim().toLowerCase());
			});

		if (remainingStyles.length) {
			el.setAttribute('style', remainingStyles.join('; '));
		} else {
			el.removeAttribute('style');
		}
	});

	root.querySelectorAll('font[face], font[size], [face]').forEach(el => {
		el.removeAttribute('face');
		if (el.tagName === 'FONT') {
			el.removeAttribute('size');
		}
	});
}

// Font attributes the answer box owns. Agent Assist content must adopt them
// instead of carrying whatever family/size the model happened to emit.
const CK5_FONT_MODEL_ATTRIBUTES = ['fontFamily', 'fontSize'];

// The reply editor has no schema for these, so CKEditor 5 drops the element and
// everything it wraps on upcast. Swapping the wrapper for a supported one keeps
// the structure the Agent Assist panel showed.
const AGENT_ASSIST_BLOCK_REPLACEMENTS = {
	ARTICLE: 'p',
	DIV: 'p',
	FOOTER: 'p',
	H4: 'h3',
	H5: 'h3',
	H6: 'h3',
	HEADER: 'p',
	MAIN: 'p',
	PRE: 'p',
	SECTION: 'p'
};

const AGENT_ASSIST_INLINE_UNWRAP = 'font, code, kbd, samp, small, big, tt, aside';

const CODE_FENCE_OPEN = /^\s*```[a-z]*[ \t]*\r?\n?/i;
const CODE_FENCE_CLOSE = /\r?\n?[ \t]*```\s*$/;

const MARKDOWN_HINT = /(^|\n)\s*(#{1,6}\s|[-*+]\s|\d+\.\s)|\*\*[^*\n]+\*\*|__[^_\n]+__|\[[^\]\n]+\]\([^)\n]+\)/;

function escapeHtmlText(text) {
	return text
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

function markdownInlineToHtml(text) {
	return escapeHtmlText(text)
		.replace(/\[([^\]\n]+)\]\(([^)\s]+)\)/g, '<a href="$2">$1</a>')
		.replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
		.replace(/__([^_\n]+)__/g, '<strong>$1</strong>')
		.replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>')
		.replace(/`([^`\n]+)`/g, '<span>$1</span>');
}

/**
 * The AI is asked for HTML but regularly answers in markdown. The Agent Assist
 * bubble hides that (markdown reads fine as text), the answer box does not - the
 * asterisks and dashes land in the reply verbatim. Convert the common markdown
 * constructs so bold, lists and headings survive the insert.
 *
 * @param {string} text - Markdown-ish plain text
 * @returns {string} - HTML
 */
export function markdownishToHtml(text) {
	if (typeof text !== 'string' || text === '') {
		return '';
	}

	const lines = text.replace(/\r\n?/g, '\n').split('\n');
	const out = [];
	let listTag = null;
	let paragraph = [];

	const closeParagraph = () => {
		if (paragraph.length) {
			out.push(`<p>${paragraph.join('<br>')}</p>`);
			paragraph = [];
		}
	};
	const closeList = () => {
		if (listTag) {
			out.push(`</${listTag}>`);
			listTag = null;
		}
	};
	const openList = tag => {
		if (listTag !== tag) {
			closeList();
			out.push(`<${tag}>`);
			listTag = tag;
		}
	};

	lines.forEach(line => {
		const heading = line.match(/^\s*(#{1,6})\s+(.*)$/);
		const bullet = line.match(/^\s*[-*+]\s+(.*)$/);
		const numbered = line.match(/^\s*\d+[.)]\s+(.*)$/);

		if (heading) {
			closeParagraph();
			closeList();
			const level = Math.min(heading[1].length, 3);
			out.push(`<h${level}>${markdownInlineToHtml(heading[2])}</h${level}>`);
		} else if (bullet) {
			closeParagraph();
			openList('ul');
			out.push(`<li>${markdownInlineToHtml(bullet[1])}</li>`);
		} else if (numbered) {
			closeParagraph();
			openList('ol');
			out.push(`<li>${markdownInlineToHtml(numbered[1])}</li>`);
		} else if (line.trim() === '') {
			closeParagraph();
			closeList();
		} else {
			closeList();
			paragraph.push(markdownInlineToHtml(line));
		}
	});

	closeParagraph();
	closeList();

	return out.join('');
}

function replaceUnsupportedBlocks(root) {
	Object.keys(AGENT_ASSIST_BLOCK_REPLACEMENTS).forEach(tag => {
		Array.from(root.getElementsByTagName(tag)).forEach(el => {
			// A wrapper holding real blocks must go away entirely, otherwise the
			// replacement paragraph would nest blocks and get flattened anyway.
			if (el.querySelector('p, div, ul, ol, table, h1, h2, h3, h4, h5, h6, blockquote')) {
				while (el.firstChild) {
					el.parentNode.insertBefore(el.firstChild, el);
				}
				el.parentNode.removeChild(el);
				return;
			}

			const replacement = document.createElement(AGENT_ASSIST_BLOCK_REPLACEMENTS[tag]);
			while (el.firstChild) {
				replacement.appendChild(el.firstChild);
			}
			el.parentNode.replaceChild(replacement, el);
		});
	});
}

function unwrapInlineElements(root) {
	root.querySelectorAll(AGENT_ASSIST_INLINE_UNWRAP).forEach(el => {
		while (el.firstChild) {
			el.parentNode.insertBefore(el.firstChild, el);
		}
		el.parentNode.removeChild(el);
	});
}

/**
 * Turn an Agent Assist answer into HTML the CKEditor 5 answer box keeps intact.
 * Handles the three ways formatting was getting lost: markdown answers, code
 * fences around the HTML, and tags/attributes the editor schema drops silently.
 * Font family and size are removed on purpose - the answer box font is applied
 * afterwards so inserted text matches the surrounding reply.
 *
 * @param {string} value - Raw Agent Assist message content
 * @returns {string} - HTML safe to hand to CKEditor 5
 */
export function agentAssistHtmlForEditor(value) {
	if (typeof value !== 'string' || value.trim() === '') {
		return '';
	}

	// Models like to wrap the answer in a ``` fence. Strip it, opener first, so a
	// half-streamed answer does not show the marker either.
	let html = value.replace(CODE_FENCE_OPEN, '').replace(CODE_FENCE_CLOSE, '');

	if (!/<[a-z][\s\S]*>/i.test(html)) {
		html = MARKDOWN_HINT.test(html) ? markdownishToHtml(html) : plainTextToHtmlPreservingBlankLines(html);
	}

	const tempDiv = document.createElement('div');
	tempDiv.innerHTML = html;

	replaceUnsupportedBlocks(tempDiv);
	unwrapInlineElements(tempDiv);
	stripInlineFontStyles(tempDiv);

	return tempDiv.innerHTML;
}

/**
 * Read the font family/size in effect at the caret, falling back to the first
 * styled text already in the editor. Used to make inserted Agent Assist content
 * match the answer box instead of the editor's bare default.
 *
 * @param {Object} editor - CKEditor 5 instance
 * @returns {Object|null} - Model attributes to apply, or null when the editor
 *                          runs on its default font
 */
export function readCk5FontAttributes(editor) {
	if (!editor || !editor.model || !editor.model.document) {
		return null;
	}

	const doc = editor.model.document;
	const attributes = {};

	CK5_FONT_MODEL_ATTRIBUTES.forEach(key => {
		const value = doc.selection.getAttribute(key);
		if (value !== undefined && value !== null) {
			attributes[key] = value;
		}
	});

	if (Object.keys(attributes).length) {
		return attributes;
	}

	const root = doc.getRoot();
	if (!root) {
		return null;
	}

	for (const item of editor.model.createRangeIn(root).getItems()) {
		if (!item.is('$textProxy') && !item.is('$text')) {
			continue;
		}
		CK5_FONT_MODEL_ATTRIBUTES.forEach(key => {
			const value = item.getAttribute(key);
			if (value !== undefined && value !== null && attributes[key] === undefined) {
				attributes[key] = value;
			}
		});
		if (Object.keys(attributes).length) {
			break;
		}
	}

	return Object.keys(attributes).length ? attributes : null;
}

function applyCk5FontAttributes(editor, writer, range, attributes) {
	if (!attributes || !range) {
		return;
	}

	const keys = Object.keys(attributes);
	if (!keys.length) {
		return;
	}

	// Collect the ranges up front: setting an attribute splits text nodes, which
	// invalidates any text proxy handed out by the range afterwards.
	const textRanges = [];
	for (const item of range.getItems()) {
		if (!item.is('$textProxy') && !item.is('$text')) {
			continue;
		}
		const allowed = keys.filter(key => editor.model.schema.checkAttribute(item, key));
		if (allowed.length) {
			textRanges.push({range: writer.createRangeOn(item), allowed});
		}
	}

	textRanges.forEach(({range: textRange, allowed}) => {
		allowed.forEach(key => writer.setAttribute(key, attributes[key], textRange));
	});
}

/**
 * Insert an Agent Assist answer into a CKEditor 5 instance keeping the answer
 * box font and the answer's own structure.
 *
 * @param {Object} editor - CKEditor 5 instance
 * @param {string} rawValue - Raw Agent Assist message content
 * @param {Object} [options]
 * @param {boolean} [options.replace] - Replace the whole answer instead of appending
 * @param {boolean} [options.atEnd] - Insert at the end of the selection (chat)
 * @returns {boolean} - Whether the content was inserted
 */
export function insertAgentAssistHtmlIntoCk5(editor, rawValue, options = {}) {
	if (!editor || !editor.model || !editor.data) {
		return false;
	}

	const html = agentAssistHtmlForEditor(rawValue);
	if (!html) {
		return false;
	}

	// Read before touching the content - setData wipes the model we sample from.
	const fontAttributes = readCk5FontAttributes(editor);

	if (options.replace) {
		editor.setData(html);
		if (fontAttributes) {
			editor.model.change(writer => {
				const root = editor.model.document.getRoot();
				if (root) {
					applyCk5FontAttributes(editor, writer, writer.createRangeIn(root), fontAttributes);
				}
			});
		}
		return true;
	}

	editor.model.change(writer => {
		const selection = editor.model.document.selection;
		const position = options.atEnd ? selection.getLastPosition() : selection.getFirstPosition();
		const viewFragment = editor.data.processor.toView(html);
		const modelFragment = editor.data.toModel(viewFragment);
		const insertedRange = editor.model.insertContent(modelFragment, position);
		applyCk5FontAttributes(editor, writer, insertedRange, fontAttributes);
	});

	return true;
}

/**
 * Same normalisation for the CKEditor 4 editors that are still around, so the
 * knowledge base answer keeps Agent Assist formatting too.
 *
 * @param {Object|string} editorOrId - CKEditor 4 instance or its element id
 * @param {string} rawValue - Raw Agent Assist message content
 * @param {boolean} replace - Replace instead of appending at the caret
 * @returns {boolean} - Whether the content was inserted
 */
export function insertAgentAssistHtmlIntoCk4(editorOrId, rawValue, replace) {
	const editor = typeof editorOrId === 'string'
		? (typeof CKEDITOR !== 'undefined' && CKEDITOR.instances[editorOrId])
		: editorOrId;
	if (!editor) {
		return false;
	}

	const html = agentAssistHtmlForEditor(rawValue);
	if (!html) {
		return false;
	}

	if (replace) {
		editor.setData(html);
		return true;
	}

	const selection = editor.getSelection();
	const ranges = selection ? selection.getRanges() : [];
	if (!ranges.length) {
		editor.setData(editor.getData() + html);
		return true;
	}

	const range = ranges[0];
	const fragment = new CKEDITOR.dom.documentFragment(editor.document);
	const tempContainer = CKEDITOR.dom.element.createFromHtml(`<div>${html}</div>`);
	while (tempContainer.getFirst()) {
		fragment.append(tempContainer.getFirst());
	}
	range.deleteContents();
	range.insertNode(fragment);

	return true;
}

/**
 * Cleans pasted HTML content by removing background-related styles and attributes.
 * This utility function strips background colors, images, and other background properties
 * from pasted content while preserving other formatting. It also adjusts text colors
 * that might become unreadable on white backgrounds after background removal.
 *
 * @param {string} htmlContent - The HTML content to clean
 * @returns {string} - The cleaned HTML content without background properties and with readable text colors
 */
export function cleanPastedContent(htmlContent) {
	if (!htmlContent || typeof htmlContent !== 'string') {
		return htmlContent;
	}

	// Create a temporary container to parse and clean the HTML
	const tempDiv = document.createElement('div');
	tempDiv.innerHTML = htmlContent;

	// Add the temporary div to the document to get computed styles
	tempDiv.style.visibility = 'hidden';
	tempDiv.style.position = 'absolute';
	tempDiv.style.top = '-9999px';
	document.body.appendChild(tempDiv);

	try {
		// Remove background-related styles from all elements and adjust text colors
		const elements = tempDiv.querySelectorAll('*');
		elements.forEach(el => {
			// Get the current computed styles before removing background
			const computedStyle = window.getComputedStyle(el);
			const backgroundColor = computedStyle.backgroundColor;
			const textColor = computedStyle.color;

			if (el.style) {
				// Check if the text color needs adjustment based on background removal
				const backgroundRGB = parseColorToRGB(backgroundColor);
				if (backgroundRGB) {
					// If background exists and text color might become unreadable on white
					if (!isReadableOnWhite(textColor)) {
						el.style.color = getReadableColorForWhite(textColor);
					}
				}

				// Remove background-related properties
				el.style.removeProperty('background');
				el.style.removeProperty('background-color');
				el.style.removeProperty('background-image');
				el.style.removeProperty('background-position');
				el.style.removeProperty('background-repeat');
				el.style.removeProperty('background-size');
				el.style.removeProperty('background-attachment');
				el.style.removeProperty('background-origin');
				el.style.removeProperty('background-clip');

				// If style attribute is empty after removing properties, remove it entirely
				if (!el.style.cssText || el.style.cssText.trim() === '') {
					el.removeAttribute('style');
				}
			}

			// Also remove any bgcolor attribute (legacy HTML)
			if (el.hasAttribute('bgcolor')) {
				el.removeAttribute('bgcolor');
			}
		});

		// Drop source fonts so paste uses the editor default family/size.
		stripInlineFontStyles(tempDiv);

		// Return the cleaned HTML content
		return tempDiv.innerHTML;
	} finally {
		// Always remove the temporary element
		document.body.removeChild(tempDiv);
	}
}

/**
 * Handles CKEditor paste events by cleaning background properties and source
 * fonts from pasted content. Pasted text then inherits the editor default font.
 *
 * @param {Object} event - The CKEditor paste event object
 * @param {string} [fontFamily] - Unused; kept for callers
 * @param {string} [fontSize] - Unused; kept for callers
 * @returns {boolean} - Returns false if content was processed, true to allow default behavior
 */
export function handleCKEditorPaste(event, fontFamily, fontSize) {

	if (!event || !event.data || !event.data.dataValue) {
		return true; // Allow default behavior if no data
	}

	// Prevent default paste to process the content
	event.stop();

	// Get the pasted HTML content
	const pastedContent = event.data.dataValue;

	// Clean the content (backgrounds + source fonts). Do not wrap in a span:
	// inner font styles would win, and a span around block tags drops blank lines.
	let cleanedContent = cleanPastedContent(pastedContent);

	// Insert the cleaned content into the editor
	if (event.editor && event.editor.insertHtml) {
		event.editor.insertHtml(cleanedContent);
	} else if (event.editor && event.editor.execCommand) {
		// Fallback: try to use CKEditor's execCommand
		event.editor.execCommand('insertHtml', cleanedContent);
	}

	return false; // Prevent default paste behavior
}
